export default [{"url":"https://hayzedd-test5-0.api.invexerp.io","name":"Branch 1","port":"5031","isStore":true,"isHQ":true}]